import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xingzhuangjiehe",
  "use": "icon-xingzhuangjiehe-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-xingzhuangjiehe\"><path d=\"M8.525.394l7.125 5.343c.22.166.35.425.35.7V15a1 1 0 01-1 1h-5v-3a1 1 0 00-1-1H7a1 1 0 00-1 1v3H1a1 1 0 01-1-1V6.437c0-.275.13-.534.35-.7L7.475.394a.875.875 0 011.05 0zm0 1a.875.875 0 00-1.05 0L1.35 5.988a.875.875 0 00-.35.7V14a1 1 0 001 1h3v-3a1 1 0 011-1h4a1 1 0 011 1v3h3a1 1 0 001-1V6.687a.875.875 0 00-.35-.7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/xingzhuangjiehe.svg
// module id = 528
// module chunks = 4